import { Typography } from '@mui/material';
import { endsWith, map, split, startsWith } from 'lodash';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Button, Modal } from '../../../components';
import { useSelector } from '../../../stores';

export const NewIrregularityPolicyModal: React.FC = () => {
  const { AITdata } = useSelector((state) => state.irregularitiesReducer);
  const [newPolicyModalIsOpen, setNewPolicyModalIsOpen] = useState(true);

  useEffect(() => {
    if (AITdata) {
      setNewPolicyModalIsOpen(
        moment().isSameOrAfter(moment(AITdata?.startAt, 'yyyy-MM-DD')),
      );
    }
  }, [AITdata]);

  return (
    <Modal
      open={newPolicyModalIsOpen}
      onClose={() => setNewPolicyModalIsOpen(false)}
      title={AITdata?.title || ''}
    >
      <div
        style={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {map(split(AITdata?.text, '\\n'), (item, index) => {
          const parts = split(item, /(\*.*?\*)/g); // Split by *...*
          return (
            <Typography key={index} sx={{ marginBottom: '15px' }}>
              {map(parts, (part, i) => {
                if (startsWith(part, '*') && endsWith(part, '*')) {
                  return <strong key={i}>{part.slice(1, -1)}</strong>;
                }
                return part;
              })}
            </Typography>
          );
        })}
        <Button
          label='Ciente'
          onClick={() => setNewPolicyModalIsOpen(false)}
          color='secondary'
          variant='contained'
          sx={{
            width: '100%',
          }}
        />
      </div>
    </Modal>
  );
};
